export class Input {
    left: boolean
    accelerate: boolean
    right: boolean
    decelerate: boolean
    fire: boolean
    continue: boolean
}